export default {
  // Words
  areYouSureToRemoveThisFile: 'Are you sure to remove this file?',
  chooseFile: 'Choose file',
  file_extension_not_accepted: 'File type is not accepted for "{fileName}". Accepted Types are "{accepted}".',
  file_max_size_exceeded: 'File max size exceeded for "{fileName}". Upload files smaller than {maxSize} KB.',
  filesNumberExceedsTheLimit: 'The number of files must be at most {max}',
  gregorianCal: 'Gregorian Calendar',
  hasError: 'Validation Error!',
  jalaliCal: 'Jalali Calendar',
  lastWeekDay: '[Last] dddd',
  today: 'Today',
  tomorrow: 'Tomorrow',
  uploading: 'Uploading',
  yesterday: 'Yesterday'
}
